// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"92d05685","872":"6d666da7"}[chunkId] + ".chunk.js";
};